module.exports = __webpack_public_path__ + "img/new_fonctionality.c38a8022.svg";